import { PrivacyScreen } from '@capacitor/privacy-screen';

export const useCapacitorPrivacyScreen = async () => {
  await PrivacyScreen.enable({
    android: {
      dimBackground: true,
      privacyModeOnActivityHidden: 'splash'
    },
    ios: {
      blurEffect: 'none'
    }
  });
};
